(function ($) {
    $(document).ready(function () {
        // Init bootstrap dropdowns
        var $topNav = $('.top-nav');
        var $dropdowns = $topNav.find('.dropdown-toggle');

        //Prevent topNav navigating to href on touch
        $dropdowns.on('touchend', function (e) {
            e.stopImmediatePropagation();
        });

        // Mouse events handlers (no touch support)
        if (!('ontouchstart' in document.documentElement)) {
            //Navigate to href when topNav is clicked
            $dropdowns.on('click', function (e) {
                if ($topNav.hasClass('open-on-hover')) {
                    e.stopImmediatePropagation();
                } else {
                    $topNav.attr('data-activated', 'true');
                }
            });

            // If the widget has the open-on-hover modifier css class
            // bind to the mouse enter to do the data-toggle
            if ($($topNav).hasClass('open-on-hover')) {
                $dropdowns.on('mouseenter', function () {
                    $topNav.attr('data-activated', 'true');
                });
            }

            // Activate a dropdown if the user already activated the menu
            // but not triggering mouseover coming back from the node's dropdown
            $dropdowns.on('mouseover', function () {
                if ($topNav.attr('data-activated') == 'true' && !$(this).parent().hasClass('open')) {
                    $(this).dropdown("toggle");
                }
            });

            // Hide the dropdown on leaving the node
            $('.navbar-nav__item').on('mouseleave', function () {
                if ($(this).hasClass('open')) {
                    $(this).find('>a').dropdown("toggle");
                }
            });

            // Hide any dropdown and deactivate the menu on leaving it
            $topNav.on('mouseleave', function () {
                $topNav.attr('data-activated', 'false');
                $dropdowns.each(function (index, value) {
                    if ($dropdowns.eq(index).parent().hasClass("open")) {
                        $dropdowns.eq(index).dropdown("toggle");
                    }
                });
            });
        }

        var additionalInfoLinkSelector = '.additional-info-link';
        var parentNodeInfoSelector = '.parent-node-info';
        var showClassName = 'show';

        // Show nav data additional info panel
        $topNav.on('mouseover', additionalInfoLinkSelector, function () {
            var id = $(this).data('id');
            var $panel = $('#' + id);
            if ($panel.length) {
                // Show the nav data panel
                $panel.addClass(showClassName);
                // Hide the parent node info
                var $parentNodePanel = $(parentNodeInfoSelector);
                if ($parentNodePanel.length) {
                    $parentNodePanel.removeClass(showClassName);
                }
            }
        });

        // Hide nav data additional info panel
        $topNav.on('mouseleave', additionalInfoLinkSelector, function () {
            var id = $(this).data('id');
            var $panel = $('#' + id);
            if ($panel.length) {
                // Hide the nav data panel
                $panel.removeClass(showClassName);
                // Show the parent node info
                var $parentNodePanel = $(parentNodeInfoSelector);
                if ($parentNodePanel.length) {
                    $parentNodePanel.addClass(showClassName);
                }
            }
        });
    });
}(jQuery));